import React from "react";

import { ChartEmptyState } from "../../../../components/States";
import { EmptySavingsStateProps } from "./types";

// Decorative rising bars: savings growing over time. Inherits its fill colour
// (white) from the illustration's front card via currentColor.
const growthChart = (
  <svg
    width="60"
    height="34"
    viewBox="0 0 60 34"
    fill="none"
    aria-hidden="true"
  >
    <rect
      x="6"
      y="22"
      width="9"
      height="12"
      rx="2"
      fill="currentColor"
      fillOpacity="0.55"
    />
    <rect
      x="20"
      y="16"
      width="9"
      height="18"
      rx="2"
      fill="currentColor"
      fillOpacity="0.7"
    />
    <rect
      x="34"
      y="9"
      width="9"
      height="25"
      rx="2"
      fill="currentColor"
      fillOpacity="0.85"
    />
    <rect x="48" y="3" width="9" height="31" rx="2" fill="currentColor" />
  </svg>
);

const FIRST_RUN_DESCRIPTION =
  "Track savings accounts, certificates and parked cash in one place. Create a savings account and its balance, deposits and interest earned appear here automatically.";
const FILTERED_DESCRIPTION =
  "No savings accounts match the current filters. Adjust the filters or create a new savings account to see it here.";

/**
 * Empty state shown when the user has no savings accounts, or none match the
 * active filters. Wraps the shared ChartEmptyState with savings-specific copy.
 */
export const EmptySavingsState: React.FC<EmptySavingsStateProps> = ({
  onCreateSavings,
  isFiltered,
  onClearFilters,
}) => {
  const title = isFiltered
    ? "No savings accounts found"
    : "Add your first savings account";
  const description = isFiltered ? FILTERED_DESCRIPTION : FIRST_RUN_DESCRIPTION;
  // Offer a one-tap reset only in the filtered "no match" state.
  const showClearFilters = isFiltered && Boolean(onClearFilters);
  const secondaryActionLabel = showClearFilters ? "Clear filters" : undefined;

  return (
    <ChartEmptyState
      chart={growthChart}
      title={title}
      description={description}
      buttonLabel="Create savings"
      onAction={onCreateSavings}
      ariaLabel="No savings accounts yet"
      secondaryActionLabel={secondaryActionLabel}
      onSecondaryAction={showClearFilters ? onClearFilters : undefined}
    />
  );
};
